import { render, staticRenderFns } from "./scrollingBox.vue?vue&type=template&id=7fec60a1&"
import script from "./scrollingBox.vue?vue&type=script&lang=js&"
export * from "./scrollingBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports